import { FeatureLimitKey, FeatureLimitKind } from 'api/graphql-global-types';

export const FEATURE_LIMIT_LABELS: Record<FeatureLimitKey, string> = {
  [FeatureLimitKey.MerchCreation]: 'Merch Creation (self-serve)',
  [FeatureLimitKey.MemorabiliaCreation]: 'Memorabilia / Product Creation',
  [FeatureLimitKey.InterviewInvite]: 'Interview Invites (as host)',
  [FeatureLimitKey.InterviewBeGuest]: 'Interview — Be a Guest',
  [FeatureLimitKey.InterviewNow]: 'Interview Now',
  [FeatureLimitKey.MediaPostImage]: 'Image Posts',
  [FeatureLimitKey.MediaPostVideo]: 'Video Posts',
  [FeatureLimitKey.StreamCreation]: 'Stream Creation',
  [FeatureLimitKey.AutoMentions]: 'Auto-Mentions (AI)',
  [FeatureLimitKey.GlobalFeedPresence]: 'Global Feed Presence',
};

export const FEATURE_LIMIT_KEYS = Object.keys(
  FEATURE_LIMIT_LABELS
) as FeatureLimitKey[];

// Keys that can only be set per user — hidden from the global defaults table
export const PER_USER_ONLY_FEATURE_LIMIT_KEYS: FeatureLimitKey[] = [
  FeatureLimitKey.AutoMentions,
  FeatureLimitKey.GlobalFeedPresence,
];

// Toggle keys are on/off policies (value 0 = off, NULL = on), not monthly counters
export const TOGGLE_STATE_LABELS: Partial<
  Record<FeatureLimitKey, { on: string; off: string }>
> = {
  [FeatureLimitKey.AutoMentions]: { on: 'Enabled', off: 'Disabled' },
  [FeatureLimitKey.GlobalFeedPresence]: {
    on: 'Visible in feed',
    off: 'Hidden from feed',
  },
};

export type ResolvedFeatureLimit = {
  featureKey: FeatureLimitKey;
  kind: FeatureLimitKind;
  monthlyLimit: number | null;
  used: number;
  remaining: number | null;
  source: 'Override' | 'Global' | 'None';
};

export type GlobalFeatureLimit = {
  id: string;
  featureKey: FeatureLimitKey;
  userId: string | null;
  monthlyLimit: number | null;
  updatedAt: string;
};

export const formatLimit = (
  monthlyLimit: number | null | undefined
): string => {
  if (monthlyLimit === null || monthlyLimit === undefined) return 'Unlimited';
  if (monthlyLimit === 0) return 'Disabled';
  return `${monthlyLimit} / month`;
};
